import { Loader } from 'components/Loader/Loader';

export function LoadingIndicator() {
  return <Loader size="xsmall" text="Loading..." />;
}
